<!-- 红迈定制打印采购单 -->
<template>
    <div v-loading="loading">
        <div id="printPurContent" class="print-zone">
            <div class="print-for" style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                    </div>

                    <div class="print-orderDetail">
                        <div class="row">
                            <div class="col col-9">
                                <label class="label_l">供应单位：</label>
                                <div class="grid-content">{{ orderData.EntpCusName }}</div>
                            </div>
                            <div class="col col-6">
                                <label class="label_l">支付方式：</label>
                                <div class="grid-content">{{ orderData.PayTypeName }}</div>
                            </div>
                            <div class="col col-6 barfa">
                                <div class="grid-content"><svg id="barcode" /></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-9">
                                <label class="label_l">单据日期：</label>
                                <div class="grid-content">{{ orderData.CreateTime }}</div>
                            </div>
                            <div class="col col-6">
                                <label class="label_l">发货方式：</label>
                                <div class="grid-content">{{ orderData.ShipTypeName }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col rkCol">
                                <label class="label_r">备注：</label>
                                <div class="grid-content">{{ orderData.Remark }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse; table-layout: fixed" bordercolor="#333333">
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="4%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="23%">
                                    <div><b>编码</b></div>
                                </td>
                                <td width="20%">
                                    <div><b>名称</b></div>
                                </td>
                                <td width="21%">
                                    <div><b>车型</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>规格</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>产地</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>单位</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>数量</b></div>
                                </td>
                                <!-- <td width="8%">
                                    <div><b>进价</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>金额</b></div>
                                </td> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td>{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Size }}</td>
                                <td>{{ AP.Origin }}</td>
                                <td>{{ AP.Unit }}</td>
                                <td>{{ AP.Count }}</td>
                                <!-- <td>{{ AP.Price }}</td>
                                <td>{{ (AP.Count * AP.Price).toFixed(2) }}</td> -->
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="8">
                                    <div style="display: inline-block; text-indent: 35px; width: 40%">
                                        <span tdata="pageNO" format="#">第#页</span> / <span tdata="pageCount" format="#">共#页</span>
                                    </div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="8" tdata="SubSum" format="#">小计数量：#</div>
                                    <div style="display: inline-block; text-align: right; width: 30%" tindex="10" tdata="SubSum" format="#,##0.00">小计金额：###</div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div id="foot">
                    <div class="order-remark btd">
                        <div style="width: 70.33333%">人民币大写：{{ capitalAmount }}</div>
                        <div style="width: 20.66667%">{{ orderData.ShipAmount > 0 ? '运费：' + orderData.ShipAmount : '' }}</div>
                        <div style="width: 20.66667%">数量：{{ orderData.TotalCount }}</div>
                        <!-- <div style="width: 20.66667%">金额：{{ orderData.SurplusMoney }}</div> -->
                    </div>
                    <div class="order-remark fwb">
                        <div>开单人：{{ orderData.SName }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="re-set">
                <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle && !orderData.IsHaveTitleSet"
                    >编辑标题</el-button
                >
                <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet && canPrint">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printPurContent'" v-else-if="canPrint">打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        //为了应对海口的未提交也可以预览的需求
        canPrint: {
            type: Boolean,
            default: true
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            orderData: {},
            allPrice: 0,
            allNum: 0,
            capitalAmount: '',
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {
                 RValue: userMsg.EntpName + '采购单'
            } //标题配置
        };
    },
    watch: {
        orderData(value) {
            if (!this.isInit) return;
            this.$nextTick(function () {
                JsBarcode('#barcode', value.OrderCode, {
                    width: 1.1,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: true
                });
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            this.getConfigByCodes().then(() => {
                this.getOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz', 'dycgbt'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dycgbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '采购单';
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                LODOP.PRINT_INIT('打印采购单');
                let topStyle = `
                    .print-title-view {
                        width: 790px;
                        position: relative;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 0;
                    }
                    .print-title {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 24px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                        padding-bottom: 5px;
                    }                    
                    .print-orderDetail {
                        width: 762px;
                        margin-bottom: 10px;
                        font-size: 14px !important;
                        color: #000;
                        padding: 0;
                        padding-left: 5px;
                        margin-right: 20px;
                    }
                    .print-orderDetail .barfa{
                        display:none;
                    }
                    .print-orderDetail .row {
                        margin-left: -10px;
                        margin-right: -10px;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        margin-bottom: 5px;
                    }
                    .print-orderDetail .row:last-child{
                        margin-bottom: 0px;
                    }                    
                    .print-orderDetail .row::after,
                    .print-orderDetail .row::before {
                        display: table;
                        content: '';
                        clear: both;
                    }
                    .print-orderDetail .row .col {
                        float: left;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 18px;
                        height: 18px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .print-orderDetail .col-5 {
                        width: 20.83333%;
                    }
                    .print-orderDetail .col-6 {
                        width: 25%;
                    }
                    .print-orderDetail .col-7 {
                        width: 29.16667%;
                    }
                    .print-orderDetail .col-8 {
                        width: 33.33333%
                    }
                    .print-orderDetail .col-9 {
                        width: 37.5%;
                    }   
                    .print-orderDetail .row .height40 {
                        height: 40px !important;
                    }

                    .print-orderDetail .row .col .label_l {
                        width: 70px;
                        text-align: left;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .print-orderDetail .row .col .label_r {
                        width: 70px;
                        text-align: right;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .print-orderDetail .row .col .grid-content {
                        display: inline-block;
                        min-height: 18px;
                        border-radius: unset;
                        line-height: 18px;
                    } 
                    .print-orderDetail .row .col .debts{
                        padding-top: 3px;
                    }
                    .print-orderDetail .row .col .grid-content::after,
                    .print-orderDetail .row .col .grid-content::before {
                        display: table;
                        content: '';
                        clear: both;
                    } 
                    .print-orderDetail .rkCol{
                        height: auto !important;
                    }
                    .print-orderDetail .rkCol .grid-content{
                        overflow: hidden !important;
                        word-break: break-all !important;
                        word-wrap: break-word !important;
                        white-space: break-spaces !important;
                        white-space: pre-wrap !important;
                        width: 65% !important;
                    }   
                    
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break: break-all;word-wrap: break-word;
                    }                     
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }
                                     
                `;

                let footStyle = `
                    .order-remark {
                        width: 762px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        padding-top: 5px;
                        color: #000;
                        width: 100%;
                        margin: 0 auto;
                        font-size: 15px;
                    }    
                    .fwb {
                        font-weight: bold;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let contentHeight = document.getElementById('printPurContent').clientHeight;
                let topHeight = document.querySelector('#printPurContent #top').clientHeight;
                let tableHeight = document.querySelector('#printPurContent #table').clientHeight;
                let footHeight = document.querySelector('#printPurContent #foot').clientHeight;
                let printTableH = 1080 - topHeight;
                if (contentHeight <= 1080) {
                    // 这里3表示纵向打印且纸高“按内容的高度”；
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    //隐藏页尾
                    tableStyle += 'tfoot{display:none;}';
                }

                LODOP.ADD_PRINT_BARCODE(35, 570, 187, 40, '128Auto', this.orderData.OrderCode);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);

                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printPurContent #top').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                // LODOP.ADD_PRINT_TABLE(topHeight + 10, 0, '100%', printTableH, `<style>${tableStyle}</style>` + document.getElementById('table').innerHTML);
                LODOP.ADD_PRINT_TABLE(topHeight + 10, 0, '100%', 'BottomMargin:10px', `<style>${tableStyle}</style>` + document.querySelector('#printPurContent #table').innerHTML);
                // LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 1); //高度包含页头页尾
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${footStyle}</style>` + document.querySelector('#printPurContent #foot').innerHTML);
                LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);

                // //设计
                // LODOP.PRINT_DESIGN();
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);

                //预览
                if (this.isPreview) LODOP.PREVIEW();
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0].id, Type: 2 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取表格数据
        getOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetHKPurOrderPrint',
                    data: {
                        EntpCusPOId: this.printIds[0].id
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let data = res.data;
                    this.orderData = res.data;
                    if (this.orderData.SurplusMoney > 0) this.capitalAmount = this.$util.moneyToCapital(this.orderData.SurplusMoney);
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        }
    }
};
</script>

<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
    padding-bottom: 5px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    // justify-content: end;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    position: relative;
}

.print-table-main {
    width: 792px;
    font-size: 14px;

    .div-table-cell {
        overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        word-break: break-all;
        word-wrap: break-word;
        height: auto;
        // line-height: 30px;
        line-height: 25px;
        padding-left: 1px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .tableConten {
        .div-table-cell {
            // line-height: 14px;
            // padding-top: 3px;
            line-height: 14px;
            //上下垂直居中
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            padding-bottom: 5px;
            padding-top: 5px;
        }
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fdzt {
    font-size: 14px;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
.fwb {
    font-weight: bold;
}
.btd {
    border-bottom: 1px dashed #000;
    font-weight: bold;
    font-size: 15px;
}

.print-orderDetail {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
}
.print-orderDetail .row {
    margin-left: -10px;
    margin-right: -10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 5px;
}
.print-orderDetail .row:last-child {
    margin-bottom: 0px;
}
.print-orderDetail .row::after,
.print-orderDetail .row::before {
    display: table;
    content: '';
    clear: both;
}

.print-orderDetail .row .col {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 18px;
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.print-orderDetail .col-5 {
    width: 20.83333%;
}
.print-orderDetail .col-6 {
    width: 25%;
}
.print-orderDetail .col-7 {
    width: 29.16667%;
}
.print-orderDetail .col-8 {
    width: 33.33333%;
}
.print-orderDetail .col-9 {
    width: 37.5%;
}

.print-orderDetail .row .height40 {
    height: 40px !important;
}
.print-orderDetail .row .barfa {
    height: auto;
    position: absolute;
    right: 30px;
}

.print-orderDetail .row .col .label_l {
    width: 70px;
    text-align: left;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.print-orderDetail .row .col .label_r {
    width: 70px;
    text-align: right;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}

.print-orderDetail .row .col .grid-content {
    display: inline-block;
    min-height: 18px;
    line-height: 18px;
    border-radius: unset;
}
.print-orderDetail .row .col .debts {
    padding-top: 3px;
}
.print-orderDetail .row .col .grid-content::after,
.print-orderDetail .row .col .grid-content::before {
    display: table;
    content: '';
    clear: both;
}
.print-orderDetail .rkCol {
    height: auto !important;
}
.print-orderDetail .rkCol .grid-content {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: pre-wrap !important;
    white-space: break-spaces !important;
    width: 65% !important;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
tfoot {
    display: none;
}
</style>
